import React from 'react'
import { Link } from 'react-router-dom'
import { Footer } from '../../components/Footer'
import { useAuth } from '../../contexts/useAuthUser'
import './styles.css'

type Props = {
  children: React.ReactNode
}

export const WebsitePage: React.FC<Props> = ({
  children
}) => {
  const { authUser } = useAuth()

  return (
    <main className="website-page"> 
      <header>
        <a href="/" className="logo">
          <img src="/assets/logo.png" alt="Phrayz" height="50" />
        </a>

        { !authUser && (
          <>
            <Link className="primary-outline" to="/login" title="Generate Content">
                  Log In
            </Link>

            <Link className="primary" to="/login" title="Generate Content">
                  Try For Free
            </Link>
          </>
        )}

        { authUser && (
          <Link className="primary" to="/app/inboxes" title="Go to Dashboard">
            <span>Dashboard</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#FFF" viewBox="0 0 256 256"><path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"></path></svg>
          </Link>
        )}
      </header>
      <div className="content">
        { children }
      </div>
      <Footer />
    </main>
  )
}

